import React, { Suspense, useState } from 'react';
import { Link } from 'react-router-dom';
import '../App.css';

const Viewport3D = React.lazy(() => import('./Viewport3D'));

function ProjectHomeCard(props) {
  const m = props.projectModel;
  const [hovered, setHovered] = useState(false);
  return (
    <div className="project-home-card">
      {m.viewport3D ? (
        <Suspense fallback={<div className="rollover" style={{ backgroundColor: '#1a1a1a' }} />}>
          <Viewport3D />
        </Suspense>
      ) : (
        <div className="rollover" style={{ backgroundColor: 'transparent' }}>
          <Link to={m.pageUrl} className="item">
            <div
              style={{ position: 'relative' }}
              onMouseEnter={() => setHovered(true)}
              onMouseLeave={() => setHovered(false)}
            >
              <img src={m.imageUrl} alt={m.altDescription} className="homepage-image" style={{ display: 'block', width: '100%' }} />
              <div style={{
                position: 'absolute',
                inset: 0,
                backgroundColor: m.rolloverColor || '#d8b1ff',
                opacity: hovered ? 0.85 : 0,
                transition: 'opacity 0.3s ease',
                pointerEvents: 'none',
              }} />
            </div>
          </Link>
        </div>
      )}
      <div className="caption">{m.client}</div>
      <div className="title">{m.title}</div>
      {m.caseStudy && m.tagline && (
        <div className="case-study-excerpt">{m.tagline}</div>
      )}
    </div>
  );
}

export default ProjectHomeCard;
